/** 0 uses → `first`; below `helpUses` → `learning`; otherwise `regular`. */
export function confirmStage(config, uses) {
    if (uses <= 0)
        return 'first';
    return uses < config.powerupConfirm.helpUses ? 'learning' : 'regular';
}
